export default "__VITE_ASSET__Cyp5BBy8__"